import { NavLink } from "react-router-dom";
import {
  ClipboardList,
  FilePlus,
  FileText,
  FolderInput,
  Package,
  Plus,
  Truck,
  Upload,
  Users,
} from "lucide-react";

function linkClass(isActive: boolean) {
  return [
    "group mb-2 flex gap-4 rounded-lg border-l-[3px] p-3 text-left transition-colors duration-150",
    isActive ? "border-teal-500 bg-teal-50" : "border-transparent bg-orange-50/35 hover:bg-orange-100",
  ].join(" ");
}

function titleClass(isActive: boolean) {
  return isActive
    ? "text-sm font-medium text-teal-900"
    : "text-sm font-medium text-slate-900 transition-colors duration-150 group-hover:text-slate-950";
}

function descClass(isActive: boolean) {
  return isActive
    ? "text-xs text-orange-800"
    : "text-xs text-orange-800 transition-colors duration-150";
}

export function GestionFacturationPanel({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <div className="flex flex-col gap-0">
      <NavLink
        to="/gestion/factures-vente"
        state={{ navFrom: "gestion" }}
        onClick={() => onNavigate?.()}
        className={({ isActive }) => linkClass(isActive)}
      >
        {({ isActive }) => (
          <>
            <FileText className="h-6 w-6 shrink-0 text-slate-600" strokeWidth={1.8} />
            <div>
              <div className={titleClass(isActive)}>Factures (natives)</div>
              <div className={descClass(isActive)}>Facturation Woahda — factures clients</div>
            </div>
          </>
        )}
      </NavLink>
      <NavLink
        to="/gestion/factures-vente/importees"
        state={{ navFrom: "gestion" }}
        onClick={() => onNavigate?.()}
        className={({ isActive }) => linkClass(isActive)}
      >
        {({ isActive }) => (
          <>
            <FolderInput className="h-6 w-6 shrink-0 text-slate-600" strokeWidth={1.8} />
            <div>
              <div className={titleClass(isActive)}>Factures importées</div>
              <div className={descClass(isActive)}>PDF / image — comptabilisation seule</div>
            </div>
          </>
        )}
      </NavLink>
      <NavLink
        to="/gestion/factures-vente/import"
        state={{ navFrom: "gestion" }}
        onClick={() => onNavigate?.()}
        className={({ isActive }) => linkClass(isActive)}
      >
        {({ isActive }) => (
          <>
            <Upload className="h-6 w-6 shrink-0 text-slate-600" strokeWidth={1.8} />
            <div>
              <div className={titleClass(isActive)}>Importer des fichiers</div>
              <div className={descClass(isActive)}>Déposer des factures (OCR)</div>
            </div>
          </>
        )}
      </NavLink>
      <NavLink
        to="/gestion/devis"
        onClick={() => onNavigate?.()}
        className={({ isActive }) => linkClass(isActive)}
      >
        {({ isActive }) => (
          <>
            <ClipboardList className="h-6 w-6 shrink-0 text-slate-600" strokeWidth={1.8} />
            <div>
              <div className={titleClass(isActive)}>Devis</div>
              <div className={descClass(isActive)}>Liste des devis</div>
            </div>
          </>
        )}
      </NavLink>
      <NavLink
        to="/gestion/factures-vente/nouvelle"
        onClick={() => onNavigate?.()}
        className={({ isActive }) => linkClass(isActive)}
      >
        {({ isActive }) => (
          <>
            <Plus className="h-6 w-6 shrink-0 text-slate-600" strokeWidth={1.8} />
            <div>
              <div className={titleClass(isActive)}>Nouvelle facture</div>
              <div className={descClass(isActive)}>Créer une facture de vente</div>
            </div>
          </>
        )}
      </NavLink>
      <NavLink
        to="/gestion/devis/nouveau"
        onClick={() => onNavigate?.()}
        className={({ isActive }) => linkClass(isActive)}
      >
        {({ isActive }) => (
          <>
            <FilePlus className="h-6 w-6 shrink-0 text-slate-600" strokeWidth={1.8} />
            <div>
              <div className={titleClass(isActive)}>Nouveau devis</div>
              <div className={descClass(isActive)}>Établir un devis client</div>
            </div>
          </>
        )}
      </NavLink>
      <NavLink
        to="/gestion/produits"
        onClick={() => onNavigate?.()}
        className={({ isActive }) => linkClass(isActive)}
      >
        {({ isActive }) => (
          <>
            <Package className="h-6 w-6 shrink-0 text-slate-600" strokeWidth={1.8} />
            <div>
              <div className={titleClass(isActive)}>Produits</div>
              <div className={descClass(isActive)}>Catalogue produits et services</div>
            </div>
          </>
        )}
      </NavLink>
      <NavLink
        to="/gestion/clients"
        onClick={() => onNavigate?.()}
        className={({ isActive }) => linkClass(isActive)}
      >
        {({ isActive }) => (
          <>
            <Users className="h-6 w-6 shrink-0 text-slate-600" strokeWidth={1.8} />
            <div>
              <div className={titleClass(isActive)}>Clients</div>
              <div className={descClass(isActive)}>Gérer vos clients</div>
            </div>
          </>
        )}
      </NavLink>
    </div>
  );
}

export function GestionFacturesAchatPanel({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <div className="flex flex-col gap-0">
      <NavLink
        to="/gestion/factures-achat"
        onClick={() => onNavigate?.()}
        className={({ isActive }) => linkClass(isActive)}
      >
        {({ isActive }) => (
          <>
            <FileText className="h-6 w-6 shrink-0 text-slate-600" strokeWidth={1.8} />
            <div>
              <div className={titleClass(isActive)}>Factures</div>
              <div className={descClass(isActive)}>Liste des factures d&apos;achat</div>
            </div>
          </>
        )}
      </NavLink>
      <NavLink
        to="/gestion/fournisseurs"
        onClick={() => onNavigate?.()}
        className={({ isActive }) => linkClass(isActive)}
      >
        {({ isActive }) => (
          <>
            <Truck className="h-6 w-6 shrink-0 text-slate-600" strokeWidth={1.8} />
            <div>
              <div className={titleClass(isActive)}>Vos fournisseurs</div>
              <div className={descClass(isActive)}>Gérer vos fournisseurs</div>
            </div>
          </>
        )}
      </NavLink>
    </div>
  );
}
